const home = {
  path: '/home',
  name: 'Home',
  icon: 'el-icon-goods',
  hidden: true,
  meta: {
    title: 'dashboard',
    icon: 'dashboard',
    affix: true
  },
  component: () => import('@/pages/home/home-new2.vue')
}
export default home
